import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }

import { ref, computed } from 'vue';
import type { LanguageTranslationValue } from '@/venit/services/model/techpubs-cms';
import { useTranslationStore } from '@/stores';
import { useI18n } from '@/shared/composables/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'languages-edit-dialog',
  props: {
    translations: {},
    title: {},
    iconOnly: { type: Boolean, default: false }
  },
  emits: ["update:translations"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t: $t } = useI18n();
const translationStore = useTranslationStore();
const translationLanguages = computed(() => translationStore.translationLanguages);

const tooltipTranslations = computed(() =>
  [...props.translations].sort((a, b) => a.langCode.localeCompare(b.langCode)).slice(0, 10)
);

const langUniqueRule = (translation: LanguageTranslationValue) => (v: string) =>
  !v || localTranslations.value.filter(t => t.langCode === v).length <= 1 || $t('component-languages.validation.langDuplicate');

const dialogOpen = ref(false);
const localTranslations = ref<LanguageTranslationValue[]>([]);
const formRef = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(null);

const openDialog = () => {
  localTranslations.value = props.translations.map(t => ({ ...t }));
  dialogOpen.value = true;
};

const cancel = () => {
  dialogOpen.value = false;
};

const save = async () => {
  const { valid } = await formRef.value?.validate() ?? { valid: true };
  if (!valid) return;
  emit('update:translations', localTranslations.value);
  dialogOpen.value = false;
};

const removeLang = (selectedTranslation: LanguageTranslationValue) => {
  localTranslations.value = localTranslations.value.filter(t => t !== selectedTranslation);
};

const addLangRow = () => {
  localTranslations.value = [...localTranslations.value, { langCode: '', name: '' }];
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.iconOnly)
      ? (_openBlock(), _createBlock(_component_v_tooltip, {
          key: 0,
          location: "top"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createVNode(_component_v_btn, _mergeProps({
              icon: "",
              variant: "text"
            }, tooltipProps, { onClick: openDialog }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-translate", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          default: _withCtx(() => [
            (__props.translations.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tooltipTranslations.value, (t) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: t.langCode
                    }, _toDisplayString(t.langCode) + ": " + _toDisplayString(t.name), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (__props.translations.length > 10)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "..."))
                    : _createCommentVNode("v-if", true)
                ]))
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          variant: "outlined",
          onClick: openDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })),
    _createVNode(_component_v_dialog, {
      modelValue: dialogOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogOpen).value = $event)),
      "max-width": "1200px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, { color: "surface-variant" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-close", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "formRef",
                  ref: formRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localTranslations.value, (translation, index) => {
                          return (_openBlock(), _createBlock(_component_v_row, { key: index }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    density: "compact",
                                    items: translationLanguages.value,
                                    modelValue: translation.langCode,
                                    "onUpdate:modelValue": ($event: any) => ((translation.langCode) = $event),
                                    "item-value": "lang",
                                    "item-title": "description",
                                    label: _unref($t)('component-languages.edit.lang'),
                                    rules: [v => !!v || _unref($t)('component-languages.validation.langRequired'), langUniqueRule(translation)]
                                  }, null, 8 /* PROPS */, ["items", "modelValue", "onUpdate:modelValue", "label", "rules"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    label: _unref($t)('component-languages.edit.name'),
                                    modelValue: translation.name,
                                    "onUpdate:modelValue": ($event: any) => ((translation.name) = $event),
                                    rules: [v => !!v || _unref($t)('component-languages.validation.nameRequired')]
                                  }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue", "rules"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "2",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    icon: "",
                                    variant: "text",
                                    onClick: ($event: any) => (removeLang(translation))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                          _createTextVNode("mdi-delete", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      })
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: addLangRow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)('component-languages.edit.add')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)('component-languages.edit.cancel')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  variant: "elevated",
                  color: "primary",
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)('component-languages.edit.save')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})